














































   import AbpBase from "../../../lib/abpbase"; 
   import {Component, Vue, Inject, Prop, Watch} from 'vue-property-decorator';
   import {SaveTabTemp} from '../../../api/systemBasic'
   import util from '../../../lib/util'
   import {GetConfigureProjects } from "@/api/sys";
   @Component({})
   export default class  extends AbpBase{
       @Prop({type:Boolean,default:false}) value:boolean;
       @Prop({type:Object,default:{}}) data:any;
       form:any = {
           tabId:this.data.info.id,
           tabName:this.data.info.name,
           type:'固定页',
           orderBy:99, 
           name:'',
           sqlName:'',
           url:''
       }
       sqlNameShow = true;
       sqlNames:any=[];
       sqlNamesAll: any = {};
       created() {
           console.log(this.data)
           if(this.data.title=='编辑'){
               this.form = Object.assign({},this.data.row)
           }
           this.getselect();
       }
       rules = {
           title:[{required: true,message:this.L('FieldIsRequired'),trigger: 'blur'}],
       }
       cancel(){
           (this.$refs.form as any).resetFields();
           this.$emit('input',false);
       }
       visibleChange(value:boolean){
           if(!value){
               this.$emit('input',value);
           }
       }
       async save(){
           (this.$refs.form as any).validate(async (valid:boolean)=>{
               if(valid){
                   let res = await SaveTabTemp(this.form)
                   if(res.status==1){
                       this.$emit('input',false);
                       this.$emit('on-success')
                   }
               }
           })
           
       }
       projectChange() {
           this.sqlNameShow = false;
           this.sqlNames = [];
           if (this.form.type == "Sql维护") {
               this.sqlNames = this.sqlNamesAll.projectsSql;
               this.form.url = "@/views/tool/sqlMaintain/sqlForData";
           } else if (this.form.type == "表单设计器") {
               this.sqlNames = this.sqlNamesAll.projectsForm;
               this.form.url = "@/views/tool/sqlMaintain/sqlForFrom";
           } else if (this.form.type == "BI报表") {
               this.sqlNames = this.sqlNamesAll.projectsBIReport;
                this.form.url = "@/views/tool/biReport/preview";
           } 
           this.sqlNameShow = true;
       }
       async getselect(){
           let configureProjects = await GetConfigureProjects();
           this.sqlNamesAll = configureProjects.objects;
           this.projectChange();
       }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/tool/tabMaintain/model.vue